import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { BankIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requirePermission, requireModules } from '../../route';

const CheckDepositsPage = lazyRouteComponent(() =>
  import('./CheckDepositsPage').then((module) => ({
    default: module.CheckDepositsPage,
  })),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-receivable/check-deposits',
  staticData: {
    app: {
      nav: {
        label: msg('Check Deposits', {
          context: 'sidebar nav label, Accounts Receivable section',
        }),
        icon: <BankIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Receivable',
        order: 16,
      },
      access: {
        modulesAnyOf: [ProductModule.AR_INVOICING],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.ARCash }],
      },
    },
  },
  component: CheckDepositsPage,
  loader: () => ({
    crumb: msg('Check Deposits', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({ context, oneOf: [ProductModule.AR_INVOICING] });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.ARCash,
    });
  },
});
